import type {TypedTranslation} from '../../../i18n';

export const UPDATE_ERROR = 'UPDATE_ERROR';

interface KeyItem {
    key?: string[];
}

interface RequestParam {
    [key: string]: KeyItem[];
}

interface ValidationError {
    requestParams?: RequestParam[];
}

export interface IUpdateError {
    type: typeof UPDATE_ERROR;
    error: {
        status: string;
        message: TypedTranslation;
        raw: object;
    };
}

export type errorReducerType = IUpdateError;

export type validationErrorType = ValidationError;
